export default __webpack_public_path__ + "static/B0012-158a30153c3231c6e555ef1458691ef6.png";